import { useStyle } from "../style";
import { SvgIcon } from "@mui/material";
import billIconImg from "@static/img/dashboard/bill.svg";

export const BillIcon = () => {
    const { classes } = useStyle({});

    return <SvgIcon className={classes.iconBox} component={billIconImg} viewBox="0 0 30 30" />;
};
